module.exports = __webpack_public_path__ + "img/190f62a9a08ec07ca7738b367a9aef5e.png";


//////////////////
// WEBPACK FOOTER
// ./classes/heroes/seb/assets/sprites/seb_07.png
// module id = 64
// module chunks = 0